import Vue from 'vue';

import '@tencent/qcvue2/dist/qcvue.css';
import 'static/cos-browser/cos-browser.css';
import '@/assets/global.scss';

import axios from 'axios';
import QcVue, { locale as localeQcVue } from '@tencent/qcvue2';
import i18n from '@/scripts/lang';

import { store, mutations } from '@/scripts/store';
import router from '@/scripts/router';
import '@/scripts/helper/user';
import '@/scripts/filters/index';
import '@/scripts/directives/index';
import '@/scripts/helper/keymap';
import '@/scripts/helper/devmode';
import App from './App.vue';

Vue.config.productionTip = false;
Vue.use(QcVue);
localeQcVue.i18n(key => i18n.t(key));

Vue.prototype.$http = axios;
Vue.prototype.$store = store;
Vue.prototype.$mutations = mutations;

new Vue({
  router,
  i18n,
  render: h => h(App),
}).$mount('#app');
